import React from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppProfileMenu from '../../designe/app-profile-menu/AppProfileMenu';
import GlobalSearch from '../global-search/GlobalSearch';
import InAppNotificationsNavButton from '../in-app-notifications/InAppNotificationsNavButton';
import { useStyles } from './Header.styles';

interface HeaderProps {
  children: React.ReactNode;
}

const Header = (props: HeaderProps) => {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <header className={classes.headerWrapper}>
      <Box className={classes.headerContent}>
        <Box className={classes.leftPart}>{props.children}</Box>
        <Box className={classes.searchWrapper}>
          <GlobalSearch />
        </Box>
        <Box className={classes.rightPart}>
          <InAppNotificationsNavButton />
          <AppProfileMenu />
        </Box>
      </Box>
    </header>
  );
};

export default Header;
